// extracted by mini-css-extract-plugin
export default {"windowsContainer":"Windows_windowsContainer__+bym2"};